// extracted by mini-css-extract-plugin
export default {"LoginContent":"Login_LoginContent__96lar"};